import React from 'react';
import { Facebook, Twitter, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-17">
          {/* Company Info */}
          <div data-id="element-18">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-19">
              Desert Sage Seminars
            </h3>
            <div className="space-y-3 text-sm" data-id="element-20">
              <p className="flex items-start" data-id="element-21">
                <MapPin className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-22" />
                <span data-id="element-23">Phoenix, Arizona</span>
              </p>
              <p className="flex items-center" data-id="element-24">
                <Phone className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-25" />
                <a href="tel:6023776207" className="hover:text-white" data-id="element-26">
                  602-377-6207
                </a>
              </p>
              <p className="flex items-center" data-id="element-27">
                <Mail className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-28" />
                <a href="mailto:info@desertsageseminars.com" className="hover:text-white" data-id="element-29">
                  info@desertsageseminars.com
                </a>
              </p>
            </div>
            <div className="mt-6 flex space-x-4" data-id="element-30">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-31">
                <Facebook className="w-5 h-5" data-id="element-32" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-33">
                <Twitter className="w-5 h-5" data-id="element-34" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-35">
                <Linkedin className="w-5 h-5" data-id="element-36" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-37">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-38">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-41">
                  Online Classes
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-43">
                  Zoom Classes
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-45">
                  Live Classes
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-47">
                  Class Schedule
                </a>
              </li>
              <li data-id="element-48">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-49">
                  My Account
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-51">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div data-id="element-52">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-53">Accreditation</h3>
            <div className="space-y-4 text-sm" data-id="element-54">
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-55">
                <p className="font-semibold text-white mb-1" data-id="element-56">
                  ADRE School #S06-0002
                </p>
                <p className="text-xs text-gray-400" data-id="element-57">
                  Approved by the Arizona Department of Real Estate
                </p>
              </div>
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-58">
                <p className="font-semibold text-white mb-1" data-id="element-59">REEA Member</p>
                <p className="text-xs text-gray-400" data-id="element-60">
                  Real Estate Educators Association
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-61">
          <p data-id="element-62">
            &copy; {new Date().getFullYear()} Desert Sage Seminars. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-63">
            <a href="#" className="hover:text-white" data-id="element-64">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-65">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}